import { Entry } from '../Entry'

export function Entry20250723() {
  return (
    <Entry title="2025 Jul 23 - v3.10.16">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17926/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
